<template>
  <div
    class="none-customer-form"
  >
    <v-subheader>{{ title }}</v-subheader>
    <v-row class="">
      <v-col cols="11" class="none-customer-form-col">
        <v-text-field
          v-model="customer.name"
          :label="lang.orders.new.customer.none"
          type="text"
          autocomplete="new-password"
          hide-details
          filled
        ></v-text-field>
      </v-col>
      <v-col cols="1" class="none-customer-form-col">
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              @click.stop="confirmCustomer"
              color="primary"
              small
              dark
              style="height: 100%;"
            >
              <v-icon>mdi-account-plus</v-icon>
            </v-btn>
          </template>
          <span>{{ lang.customers.widget.confirmRegister }}</span>
        </v-tooltip>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'

export default {
  mixins: [ appdata, utils ],
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      customer: {
        id: -1,
        name: '',
        confirm: false
      },
      timeout: null
    }
  },
  methods: {
    confirmCustomer () {
      let output = { ...this.customer }
      output.confirm = true
      this.$emit('confirmCustomer', output)
    }
  }
}
</script>
